import React from 'react'
import {BsTwitter, BsInstagram} from 'react-icons/bs'
import {BsFacebook} from 'react-icons/bs'

const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
            <a href="https://twitter.com/MobiinAkhter" target="_blank" rel="noreferrer noopener">
              <BsTwitter/>
            </a>
        </div>
        <div>
            
            <a href="https://www.facebook.com/mobin.akhter.520" target="_blank" rel="noreferrer noopener">
              <BsFacebook/>
            </a>
        </div>
        <div>
            <a href="https://www.instagram.com/mobiinakhter/" target="_blank" rel="noreferrer noopener">
              <BsInstagram/>
            </a>
        </div>
    </div>
  )
}
export default SocialMedia
